import { closeSpecificViewOption, setActiveInput, setSelectedViewOption, toggleSelectedViewOption, } from "./eramReact/slices/commonSlice";
import { syncMcaInputAction, syncUiInputAction, syncUiScrollAction } from "./actions";
const whitelistedUiActions = [
    setSelectedViewOption.type,
    toggleSelectedViewOption.type,
    closeSpecificViewOption.type,
    setActiveInput.type,
    syncUiInputAction.type,
    syncUiScrollAction.type,
    syncMcaInputAction.type,
];
export function isRestrictedUiAction(action, prefixes = [], additionalActionTypes = [], excludedActions = []) {
    return (!excludedActions.includes(action.type) &&
        (prefixes.includes(action.type.split("/")[0]) ||
            whitelistedUiActions.includes(action.type) ||
            additionalActionTypes.includes(action.type)));
}
//# sourceMappingURL=restrictedUiAction.js.map